"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MonthlySavings_1 = require("./MonthlySavings");
exports.default = MonthlySavings_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/MonthlySavings/index.js
// module id = 414
// module chunks = 8